import type { ReactElement } from 'react';

import { Icon } from '..';

import type { ILoadingProps, TLoadingColors } from './loading.interface';

import './loading.scss';

const loadingIconColors: Partial<TLoadingColors> = {
  white: 'co-bg-common-white',
  primary: 'co-bg-primary-main',
  secondary: 'co-bg-secondary-main',
  black: 'co-bg-black-main',
  gray: 'co-bg-gray-main',
  cyanBlue: 'co-bg-cyan-blue'
};

export const Loading = ({ color, variant }: ILoadingProps): ReactElement => {
  const createIconColor = () => {
    return loadingIconColors[color ?? 'white'];
  };

  if (variant === 'circle') {
    return (
      <div className="co-flex co-items-center co-justify-center co-opacity-80">
        <Icon icon="SpinnerIcon" color={color ? color : 'gray'} />
      </div>
    );
  }
  return (
    <div className="co-flex co-gap-2 co-animation-delay">
      {[...Array(3)].fill(null).map((_, i) => (
        <div
          key={i}
          className={`
            co-animate-loader-bounce
            ${createIconColor()}
            co-w-small-px
            co-h-small-px
            co-rounded-full
          `}
        />
      ))}
    </div>
  );
};
